import Map from "./index";

const MapRoutes = [
  {
    component: Map,
    path: "/map",
    exact: true,
    type: "private",
  },
];

export default MapRoutes;
